/**
 * This is incomplete and will be updated once we use the `useUserSettings` composable more
 */
export type SettingsToPersist = {
  'view.defaultSavedViewIdMobile': number | undefined
  'view.defaultSavedViewIdDesktop': number | undefined
  'request.sendCopyToMe': boolean | undefined
}

export const settingsToPersist = {
  'persoplan.projectGroupsCollapsed': { type: Object },
  'cssVar.variables.dayWidth.value': {},
  'view.defaultSavedViewIdMobile': {},
  'view.defaultSavedViewIdDesktop': {},
  'request.sendCopyToMe': {},
} as const

export const urlParamsToPersist = {
  'persoplan.visibleStartDate': { type: Date, id: 'start-date' },
  'persoplan.visibleEndDate': { type: Date, id: 'end-date' },
  'view.id': { type: Number, id: 'view-id' },
} as const
